import { getCompaniesOfMeBasicApi } from 'api/user';
import { getAllCustom } from 'redux/crudCreatorCustom/actions';

export const MODEL_NAME = 'companiesOfMeBasic';

export const getCompaniesOfMeBasic = getAllCustom(
  MODEL_NAME,
  getCompaniesOfMeBasicApi,
);
